import { createContext } from 'react';

// تعريف السياق مع القيم الافتراضية
export const MainContext = createContext({
  user: null,
  isAdmin: false,
  loading: false,
  userId: null,
  selectedTab: "",
  setSelectedTab: () => {},
});

// تعديل المزود ليستقبل القيم من App.js
export const MainContextProvider = ({ children, value }) => {
  return (
    <MainContext.Provider value={value}>
      {children}
    </MainContext.Provider>
  );
};
